import React from 'react';
import { ReactComponent as ClockSVG } from './clock.svg';

export default function ClockIcon({width = 18, height = 18, color = '#0A0A0A'})
{
  return (
    <ClockSVG
      width={width}
      height={height}
      style={{color: color}}
    />
  );
}
